/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useEffect } from "react";
import { useState } from "react";
/// ACTIONS ///
import { sortShopOrders } from "api/actions/self_order/self_order";
/// REACT COMPONENTS ///
import { Fragment } from "react";
/// MUI COMPONENTS ///
import Grid from "@mui/material/Grid";
import SortButton from "components/universal/button/sort";
/// STYLES ///
import { row_header_style } from "styles/universal/row";
/// SORT VALUES ///
import { DATE } from "values/sort/order";
import { NAME } from "values/sort/order";
import { CUSTOMER } from "values/sort/order";
import { TOTAL } from "values/sort/order";


export default function ShopOrderHeader() {
  const dispatch = useAppDispatch();
  const [sort_type, setSortType] = useState<number>(-1);
  const [sort_up, setSortUp] = useState<boolean>(false);

  useEffect(() => {
    dispatch(sortShopOrders(sort_type, sort_up));
  }, [dispatch, sort_type, sort_up]);

  const setSort = (type: number) => {
    if (sort_type === type) {
      setSortUp(prev => !prev);
    }
    else {
      setSortType(type);
      setSortUp(false);
    }
  }

  return (
    <Fragment>
      <Grid item xs={2.5} sx={row_header_style}>
        <SortButton text="Date" handleSort={() => setSort(DATE)} is_current={sort_type === DATE} is_up={sort_up} />
      </Grid>
      <Grid item xs={3} sx={row_header_style}>
        <SortButton text="Order Name" handleSort={() => setSort(NAME)} is_current={sort_type === NAME} is_up={sort_up} />
      </Grid>
      <Grid item xs={3.5} sx={row_header_style}>
        <SortButton text="Account" handleSort={() => setSort(CUSTOMER)} is_current={sort_type === CUSTOMER} is_up={sort_up} />
      </Grid>
      <Grid item xs={3} sx={row_header_style}>
        <SortButton text="Total" handleSort={() => setSort(TOTAL)} is_current={sort_type === TOTAL} is_up={sort_up} />
      </Grid>
    </Fragment>
  )
}
